import ComponentManager from '@/Management/ComponentManager';
import ToolBarLinkViewModel from '@/Components/Links/ToolBarLinkViewModel';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import * as CoreFrameDTOs from "coreframetypings/dto";
import NavigationService from '@/Management/NavigationService';
import TableConfigViewModelT from '@/ViewModels/Views/TableConfigViewModel';

export default class TableConfigLinkViewModel extends ToolBarLinkViewModel {

    protected storageColumnDefinitionKey: string;
    protected columnDefinition: KnockoutObservable<CoreFrameDTOs.IColumnDTO>;
    protected defaultColumnDefinition: KnockoutObservable<CoreFrameDTOs.IColumnDTO>;
    protected detailViewItem: CoreFrameDTOs.IDVGItemDTO;
    private isOpened: boolean;

    public constructor(protected params: any) {
        super($.extend(params,
            {
                ergName: params.showErgname ? 'CUSTOM_COLUMNS_TOOLTIP' : '',
                tooltipErgName: 'CUSTOM_COLUMNS_TOOLTIP',
                imageSource: GlobalConfiguration.inlineImages.TOOLBAR_TABLECONFIG,
                locator: 'tableconfig'
            }));

        this.defaultColumnDefinition = this.observableOrDefault(params.defaultColumnDefinition, []);
        this.columnDefinition = this.observableOrDefault(params.columnDefinition, []);
        this.storageColumnDefinitionKey = this.paramOrDefault(params.storageColumnDefinitionKey, '');
        this.detailViewItem = this.paramOrDefault(params.detailViewItem, null);
    }

    /**
     * @override 
     * @param openInNewWindow
     * @param event
     */
    public onClick(openInNewWindow?: boolean, event?: JQuery.Event): void {
        if (this.isOpened)
            return;

        const TableConfigViewModel = ComponentManager.getViewModel<typeof TableConfigViewModelT>('TableConfigViewModel');

        this.isOpened = true;
        const tableConfig = NavigationService.getInstance().loadViewFactoryIsolated('TableConfig', {
            viewModel: new TableConfigViewModel({
                userSpecificDataKey: this.storageColumnDefinitionKey,
                parentLocator: this.locator,
                locator: this.detailViewItem.name + 'tableconfig',
                columnDefinition: this.columnDefinition,
                defaultDefinition: this.defaultColumnDefinition(),
                onClose: () => {
                    this.isOpened = false;
                    NavigationService.getInstance().removeViewFactoryIsolated(tableConfig);
                }
            })
        }, true);
    }

    protected createDefaultColumnDefinition(): KnockoutObservable<CoreFrameDTOs.IColumnDTO[]> {
        return this.observableOrDefault(this.params.defaultColumnDefinition, []);
    }
}

ComponentManager.setViewModel('EditLink', TableConfigLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');